// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"e5ecabe5e4ab844f6ff1","873":"f159c782bbc680ea2dcf"}[chunkId] + ".js";
};